export default __webpack_public_path__ + "static/media/logo-login.833f35aa.svg";